<template>
    <div :id="id" class="charts-map">
    </div>
</template>
<style lang="postcss">
    .charts-map {
        height: 500px;
    }
</style>
<script>
    import provinceData from "data/province-data";
    export default {
        props: {
            dataList: {
                type: Array,
                required: true
            },
            id: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                option: {
                    title: {
                        text: "",
                        subtext: "",
                        left: "center"
                    },
                    tooltip: {
                        trigger: "item",
                        backgroundColor: "rgba(255, 255, 255, .90)",
                        textStyle: {
                            color: "#142C3D"
                        },
                        extraCssText: "box-shadow: 0 1px 18px 0 rgba(151, 189, 208, .3);",
                        formatter: '<span style="font-weight:500">{b}</span><br/>销量占比:  {c}%'
                    },
                    legend: {
                        orient: "vertical",
                        left: "left",
                        data: []
                    },
                    visualMap: {
                        min: 0,
                        max: 100,
                        left: "left",
                        top: "90%",
                        orient: "horizontal",
                        text: ["高", "低"],
                        color: "#6E808B",
                        inRange: {
                            color: ["#e9f5fe", " #1087ed"]
                        },
                        calculable: false
                    },
                    series: [{
                        name: "",
                        type: "map",
                        mapType: "china",
                        showLegendSymbol: false, //去除地图上的指示点
                        roam: false, //地图进行缩放
                        label: {
                            normal: {
                                show: false
                            },
                            emphasis: {
                                show: true
                            }
                        },
                        data: this.convertData(this.dataList)
                    }]
                }
            };
        },
        watch: {
            dataList: function (value) {
                if (Array.isArray(value)) {
                    this.option.series[0].data = this.convertData(value);
                    this.charts.setOption(this.option);
                }
            }
        },
        created: function () {
        },
        methods: {
            convertData(data) {
                let res = [];
                for (let i = 0; i < data.length; i++) {
                    res.push({
                        name: data[i].name,
                        value: parseFloat(data[i].ratio)
                    });
                }
                provinceData.forEach(item => {
                    let flag = true;
                    for (let i = 0; i < res.length; i++) {
                        if (res[i].name.indexOf(item.name) !== -1) {
                            flag = false;
                            break;
                        }
                    }
                    if (flag) {
                        res.push({
                            name: item.name,
                            value: 0
                        });
                    }
                });
                return res;
            },
            alert(message) {
                this.$alert({
                    title: "提示",
                    message: message,
                    showCancelButton: false,
                    closeOnClickModal: false
                });
            },
            drawMap(id) {
                this.charts = echarts.init(document.getElementById(id));
                this.charts.setOption(this.option);
            }
        },
        mounted() {
            this.$nextTick(function () {
                this.drawMap(this.id);
            });
        }
    }
</script>



// WEBPACK FOOTER //
// map.vue?9c8744f8